<section class="w-full gap-2">
  <div class="w-full">
    <h2 class="text-2xl font-bold mt-5" *ngIf="accommodation() == 'ecolodge'">{{ dataSource?.Title?.split('&988&')[0] }}</h2>
    <h1 class="text-2xl font-bold mt-5" *ngIf="accommodation() != 'ecolodge'">{{ dataSource?.Title?.split('&988&')[0] }}</h1>
  </div>
  <div class="w-full mt-7">
    <ng-container *ngIf="resetSwiper()">
      <iho-swiper [dataSource]="dataSource?.Section?.Data?.Details" [configs]="sliderConfigs" />
    </ng-container>
  </div>
</section>

<ng-template #template let-data="data" let-i="index">
  <iho-hotels-card [ecolodgeType]="accommodation() == 'ecolodge' || accommodation() == 'villa-mashhad' ? 2 : 1" [dataSource]="data" [type]="2" />
</ng-template> 